<div class="sites-table-wrapper">
<ag-grid-angular id="sites-table"
*ngIf="tableData.length"
style="width: 100%;"
[rowData]="tableData"
[columnDefs]="colDefs"
[defaultColDef]="defaultColDef"
[rowSelection]="rowSelection"
[gridOptions]="gridOptions"
[modules]="modules"
[theme]="theme"
[domLayout]="'autoHeight'"
[suppressCellFocus]="true"
[enableBrowserTooltips]="true"
(gridReady)="onGridReady($event)"
></ag-grid-angular>
<app-loader *ngIf="loading"></app-loader>
</div>
